const ContextStrip = () => {
  return (
    <section className="border-y border-border bg-secondary/40 py-6 lg:py-8">
      <div className="container-tight">
        <div className="grid gap-6 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <p className="text-xl leading-relaxed text-foreground sm:text-2xl">
              AI adoption is rising across industries.
              <span className="text-muted-foreground">But measurable ROI is still unclear for most teams.</span>
            </p>
          </div>
          <div className="lg:col-span-5">
            <p className="text-sm leading-relaxed text-muted-foreground">
              Most teams delay starting not because of AI, but because the first step feels unclear. Signal AI is designed to make that first step obvious, structured, and <span className="font-medium text-foreground">low-risk</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContextStrip;
